module.exports = __webpack_public_path__ + "img/xiayiye.3eb6291b.png";